// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `

/* color file */

.scroll-top:hover{
    background: #002c5d;
  }
  
  .preloader-close{
    background: #002c5d;
  }
  
  .main-header .header-top .left-info li i{
    color: #002c5d;
  }
  
  .main-header .header-top .left-info li p a:hover{
    color: #002c5d;
  }
  
  .main-header .header-top .location-box .location-carousel p span{
    color: #002c5d;
  }
  
  .main-header .header-top .location-box .location-carousel .owl-nav .owl-prev:hover,
  .main-header .header-top .location-box .location-carousel .owl-nav .owl-next:hover{
    background: #002c5d;
  }
  
  .main-header .header-top .location-box .apply-btn a{
    color: #002c5d;
  }
  
  .main-header .header-top .right-info .list li a:hover{
    color: #002c5d;
  }
  
  .main-header .header-top .right-info .social-links li a:hover{
    color: #002c5d;
  }
  
  .main-header .menu-right-content .search-btn button:hover{
    color: #002c5d !important;
  }
  
  .theme-btn-one:after{
    background: #002c5d;
  }
  
  .main-header .language .lang-dropdown li a:hover{
    color: #ff5956;
  }

  
   .main-menu .navigation > li.dropdown.current > a:before,
   .main-menu .navigation > li.dropdown:hover > a:before{
    color: #002c5d !important;
  }
  
   .main-menu .navigation > li.current > a,
   .main-menu .navigation > li:hover > a{
    color: #002c5d !important;
  }
  
  .main-header .language .lang-dropdown{
    border-top: 2px solid #002c5d;
  }
  
  .search-popup .close-search:hover{
    color: #002c5d;
    border-color: #002c5d;
  }
  
  .search-popup .search-form fieldset input[type="submit"]{
    background: #002c5d;
  }
  
  .search-popup .recent-searches li a:hover{
    color: #002c5d;
    border-color: #002c5d;
  }
  
  .banner-carousel .content-box span{
    color: #ff5956;
  }
  
  .theme-btn-two{
    background: #002c5d;
  }
  
  .sec-title .top-title{
    color: #ff5956;
  }
  
  #content_block_1 .content-box .tab-btns li.active-btn i.employ-icon,
  #content_block_1 .content-box .tab-btns li:hover i.employ-icon,
  #content_block_1 .content-box .tab-btns li.active-btn i.arrow-icon,
  #content_block_1 .content-box .tab-btns li:hover i.arrow-icon{
    color: #ff5956;
  }
  
  #content_block_1 .content-box .tabs-content .inner-box h5{
    color: #002c5d;
  }
  
  #content_block_1 .content-box .tabs-content .inner-box .link a:hover{
    color: #002c5d;
  }
  
  #content_block_2 .content-box .inner-box a, #Button_react{
    background: #002c5d;
  }
  
  #content_block_3 .content-box .link a:hover{
    color: #002c5d;
  }
  
  #content_block_3 .content-box .author-text h3:before{
    background: #002c5d;
  }
  
  #content_block_3 .content-box .author-text h3:after{
    background: #002c5d;
  }
  
  .service-block-one .inner-box .lower-content .overlay-content a{
    background: #002c5d;
  }
  
  .owl-dot-style-one .owl-dots .owl-dot.active span,
  .owl-dot-style-one .owl-dots .owl-dot span:hover{
    background: #002c5d;
  }
  
  #content_block_4 .content-box .inner-box .single-item .inner h3 span{
    color: #002c5d;
  }
  
  #content_block_4 .content-box .inner-box .single-item .inner h3:before{
    background: #002c5d;
  }
  
  #content_block_4 .content-box .inner-box .single-item .inner h3 a:hover{
    color: #ff5956;
  }
  #procedure figure.image-box {
    background: white;
    padding: 2% 0;
}
.col-lg-4.col-md-6.col-sm-12.process-block:hover .process-block-one .inner-box .icon-box span {
  background: #002c5d !important;
  color: white;
  cursor: pointer;
}
.col-lg-4.col-md-6.col-sm-12.process-block:hover  { 
  cursor: pointer;
}
  .industries-section .content-column .tabs-content .inner-box .content-box .link a:hover{
    background: #002c5d;
  }
  
  .industries-section .tab-btns li.active-btn h3,
  .industries-section .tab-btns li:hover h3{
    color: #ff5956
  }
  
  .process-block-one .inner-box .icon-box span{
    color: #002c5d;
  }
  
  .process-block-one .inner-box .lower-content a{
    color: #002c5d;
  }
  
  .progress-box .bar-inner{
    background: #002c5d;
  }
  
  .progress-box .bar:before{
    background: #002c5d;
  }
  
  .progress-box .bar-inner:before{
    background: #002c5d;
  }
  
  #content_block_5 .content-box .link a:hover{
    color: #002c5d;
  }
  
  #content_block_5 .content-box .sec-title{
    margin-bottom: 30px;
  }
  
  .team-block-one .inner-box .image-box .share-box .social-links li a:hover{
    color: #002c5d;
  }
  
  .team-block-one .inner-box .lower-content h3 a:hover{
    color: #002c5d;
  }
  
  .news-block-one .inner-box .image-box .post-date{
    background: #002c5d;
  }
  
  .news-block-one .inner-box .lower-content .inner .category i{
    color: #002c5d;
  }
  
  .news-block-one .inner-box .lower-content .inner h3 a:hover{
    color: #002c5d;
  }
  
  .news-block-one .inner-box .lower-content .inner .post-info li a:hover{
    color: #002c5d;
  }
  
  .testimonial-block-one .inner-box .author-box .rating li{
    color: #002c5d;
  }
  
  .footer-top .about-widget .social-links li a:hover{
    color: #002c5d;
  }
  
  .footer-top .links-widget .links-list li a:hover{
    color: #ff5956;
  }
  
  .footer-top .contact-widget .info-box li a:hover{
    color: #ff5956;
  }
  
  .main-footer .footer-subscribe .subscribe-form .form-group button:hover,
  .main-footer .footer-subscribe .subscribe-form .form-group input:focus + button{
    color: #ff5956;
  }
  
  .main-footer .footer-subscribe .subscribe-form .form-group input:focus{
    border-bottom: 1px solid #002c5d !important;
  }
  
  .footer-bottom .copyright p a:hover{
    color: #002c5d;
  }
  
  .footer-bottom .footer-nav li a:hover{
    color: #ff5956;
  }
  
  .main-header.style-two .menu-right-content .theme-btn-one{
    border: 1px solid #002c5d;
  }
  
  .banner-carousel .btn-box .btn-one:after{
    background: #002c5d;
  }
  
  .banner-section .owl-nav .owl-prev:hover,
  .banner-section .owl-nav .owl-next:hover{
    background: #002c5d;
  }
  
  #image_block_1 .image-box .video-inner .border{
    border: 1px solid #002c5d !important;
  }
  
  .service-style-two .inner-container .single-item h3 a:hover{
    color: #002c5d;
  }
  
  .service-style-two .inner-container .single-item .link a i{
    color: #002c5d;
  }
  
  .service-style-two .inner-container .single-item .link a:hover{
    color: #002c5d;
  }
  
  .service-style-two .inner-container .single-item .text a:hover{
    color: #002c5d;
    border-bottom: 1px solid #002c5d;
  }
  
  .project-block-one .inner-box .content-box .text span{
    color: #002c5d;
  }
  
  .project-block-one .inner-box .content-box .text h3 a:hover{
    color: #002c5d;
  }
  
  .project-block-one .inner-box .content-box .view-btn a{
    background: #002c5d;
  }
  
  .project-section .owl-nav .owl-prev:hover,
  .project-section .owl-nav .owl-next:hover{
    color: #002c5d;
  }
  
  .industries-style-two .tab-btn-one .tab-buttons li.active-btn i{
    color: #002c5d;
  }
  
  .industries-style-two .tabs-content-2 .inner-box .content-box .link a:hover{
    background: #002c5d;
  }
  
  .industries-style-two .tab-btn-two li.active-btn h3,
  .industries-style-two .tab-btn-two li:hover h3{
    color: #002c5d;
  }
  
  .industries-style-two .tab-btn-two li.active-btn-2:before,
  .industries-style-two .tab-btn-two li:hover:before{
    background: #002c5d;
  }
  
  .chooseus-block-one .inner-box a i{
    color: #002c5d;
  }
  
  .chooseus-block-one .inner-box a:hover{
    color: #002c5d;
  }
  
  .chooseus-block-one:after{
    border: 1px solid #002c5d;
  }
  
  .pricing-block-one .inner-box .text:before{
    background: #002c5d;
  }
  
  .pricing-block-one .inner-box h2{
    color: #002c5d;
  }
  
  .pricing-block-one .inner-box:hover a{
    background: #002c5d;
  }
  
  .pricing-block-one.popular .inner-box .popular-tag{
    background: #002c5d;
  }
  
  .pricing-block-one.popular .inner-box .popular-tag:before{
    background: #002c5d;
  }
  
  .pricing-block-one.popular .inner-box .popular-tag:after{
    background: #002c5d;
  }
  
  .pricing-block-one.popular .inner-box:before{
    background: #d13634;
  }
  
  .pricing-section .tab-btn-box .tab-buttons li.active-btn,
  .pricing-section .tab-btn-box .tab-buttons li:hover{
    color: #002c5d !important;
  }
  
  .testimonial-block-two .inner-box .rating li{
    color: #002c5d;
  }
  
  .testimonial-style-two .owl-theme .owl-dots .owl-dot span:before{
    border: 1px solid #002c5d;
  }
  
  .testimonial-style-two .owl-theme .owl-dots .owl-dot.active span{
    background: #002c5d;
  }
  
  .testimonial-style-two .thumb-box .user-thumb .pattern-3{
    background: #002c5d;
  }
  
  .news-section .owl-nav .owl-prev:hover,
  .news-section .owl-nav .owl-next:hover{
    color: #002c5d;
  }
  
  .clients-style-two .title-inner .btn-box a.btn-one{
    background: #002c5d;
  }
  
  .clients-style-two .title-inner .btn-box a.btn-one:hover{
    color: #002c5d;
  }
  
  .clients-style-two .title-inner .btn-box a.btn-two:hover{
    background: #002c5d;
  }
  
  #content_block_6 .content-box .info-list li .inner p a:hover{
    color: #002c5d;
  }
  
  #content_block_6 .content-box .info-list li .inner:after{
    background: #002c5d;
  }
  
  .main-footer .about-widget .subscribe-form .form-group input:focus{
    border-color: #002c5d !important;
  }
  
  .main-footer .about-widget .subscribe-form .form-group button:hover{
    background: #002c5d;
  }
  
  .main-footer .callback-widget .widget-content .form-group input:focus{
    border-color: #002c5d !important;
  }
  
  .main-footer .callback-widget .widget-content .form-group button{
    background: #002c5d;
  }
  
  .main-footer .callback-widget .pattern-layer .pattern-3{
    background: #002c5d;
  }
  
  .footer-bottom .social-links li a:hover{
    background: #002c5d;
    border-color: #002c5d;
  }
  
  .banner-section.style-three .social-box .social-links li a:hover{
    color: #002c5d;
  }
  
  .banner-section.style-three .social-box .social-links:before{
    background: #002c5d;
  }
  
  .banner-section.style-three .mail-box a:hover{
    color: #002c5d;
  }
  
  .chooseus-section.alternet-2 .chooseus-block-one .inner-box a:hover{
    color: #002c5d;
  }
  
  .chooseus-section.alternet-2 .chooseus-block-one .inner-box a:hover i{
    color: #002c5d;
  }
  
  .video-section .video-content .pattern-layer .pattern-2{
    background: #002c5d;
  }
  
  .video-section .video-content .pattern-layer .pattern-3{
    background: #e74946;
  }
  
  .process-style-two .single-item .inner-box h2{
    color: #002c5d;
  }
  
  .process-style-two .single-item .inner-box h3 a:hover{
    color: #002c5d;
  }
  
  .process-style-two .single-item .inner-box .link a:hover{
    color: #002c5d;
  }
  
  .pricing-block-two .inner-box:hover a{
    background: #e74946;
  }
  
  .pricing-block-two .inner-box h2{
    color: #002c5d;
  }
  
  .pricing-block-two .inner-box .list li:before{
    color: #002c5d;
  }
  
  .project-style-two .more-text p a:hover{
    color: #002c5d;
    border-color: #002c5d;
  }
  
  .news-section .sec-title .link:hover{
    color: #002c5d;
  }
  
  .advice-section .text h2 a{
    color: #002c5d;
  }
  
  .advice-section .social-links li a:hover{
    background: #002c5d;
  }
  
  .main-footer .logo-widget .upload-btn a{
    border: 1px dashed #002c5d;
  }
  
  .main-footer .logo-widget .upload-btn a i{
    color: #002c5d;
  }
  
  .main-footer .logo-widget .upload-btn a:hover{
    color: #002c5d;
  }
  
  .footer-top .post-widget .post-inner .post h5 a:hover{
    color: #002c5d;
  }
  
  .page-title .bread-crumb li a:hover{
    color: #002c5d;
  }
  
  .process-style-two.alternet-2 .single-item .inner-box h3 a:hover{
    color: #002c5d;
  }
  
  .process-style-two.alternet-2 .single-item .inner-box .link a:hover{
    color: #002c5d;
  }
  
  .process-style-two.alternet-2 .single-item .inner-box .link a:hover i{
    color: #002c5d;
  }
  
  .history-section .inner-box .content-box .year-box h3{
    color: #002c5d;
  }
  
  .history-section .inner-box .dots-box.active{
    border-color: #002c5d;
  }
  
  .history-section .inner-box .dots-box.active:before{
    background: #002c5d;
  }
  
  .history-section .inner-box .dots-box.active:after{
    background: #002c5d;
  }
  
  .owl-dot-style-two .owl-dots .owl-dot.active span,
  .owl-dot-style-two .owl-dots .owl-dot span:hover{
    background: #002c5d;
  }
  
  .hiring-strategies .inner-box .funfact-inner .counter-block .count-outer{
    color: #002c5d;
  }
  
  .solutions-problems .upper-box .inner-box .single-item a:hover{
    color: #002c5d;
  }
  
  .solutions-problems .carousel-box .single-item .inner-box .side-content .content-box:after{
    background: #002c5d;
  }
  
  .solutions-problems .carousel-box .single-item .inner-box .side-content .overlay-box span{
    color: #002c5d;
  }
  
  .solutions-problems .carousel-box .single-item .inner-box .side-content .overlay-box a:hover{
    background: #002c5d;
  }
  
  .solutions-problems .carousel-box .single-item .inner-box .side-content .overlay-box:before{
    background: #002c5d;
  }
  
  .placejob-section .form-inner .job-form .form-group input:focus,
  .placejob-section .form-inner .job-form .form-group textarea:focus{
    border-color: #002c5d !important;
  }
  
  .accordion-box .block .acc-btn.active .icon-outer{
    background: #002c5d;
  }
  
  .clients-style-three .owl-nav .owl-prev:hover,
  .clients-style-three .owl-nav .owl-next:hover{
    color: #002c5d;
  }
  
  .hiring-section .inner-box a:after{
    background: #002c5d;
  }
  
  .default-form .form-group input:focus,
  .default-form .form-group textarea:focus{
    border-color: #002c5d !important;
  }
  
  .service-details-content .content-two .inner-box .single-column .overlay-box .icon-box{
    background: #002c5d;
  }
  
  .service-details-content .content-two .inner-box .single-column .overlay-box h5{
    color: #002c5d;
  }
  
  .service-details-content .content-two .inner-box .single-column .overlay-box .link a:hover{
    color: #002c5d;
  }
  
  .service-details-content .content-three .tab-btns li.active-btn .icon-box{
    color: #002c5d;
  }
  
  .service-details-content .content-three .tabs-content .inner-box .text a:hover{
    color: #002c5d;
  }
  
  .service-details-content .content-four .inner-box .list-item li .icon-box{
    color: #002c5d;
  }
  
  .service-details-content .content-four .inner-box .list-item li:hover .more-content .menu-icon i{
    color: #002c5d;
  }
  
  .project-block-two .inner-box .content-box .link a{
    background: #002c5d;
  }
  
  .project-block-two .inner-box .content-box .text h3 a:hover{
    color: #002c5d;
  }
  
  .service-details-content .content-five .owl-nav .owl-prev:hover, 
  .service-details-content .content-five .owl-nav .owl-next:hover{
    color: #002c5d;
  }
  
  .service-sidebar .categories-widget .categories-list li a.active:before,
  .service-sidebar .categories-widget .categories-list li a:hover:before{
    border-color: #002c5d;
  }
  
  .service-sidebar .categories-widget .categories-list li a:after{
    background: #002c5d;
  }
  
  .service-sidebar .recruitment-widget .widget-content .link a:hover{
    color: #002c5d;
  }
  
  .single-job-post .job-header .number p{
    color: #002c5d;
  }
  
  .single-job-post:hover .job-inner .apply-btn a{
    background: #002c5d;
    border-color: #002c5d;
  }
  
  .job-details-content .upper-box .inner-box .info li a:hover{
    color: #002c5d;
  }
  
  .job-details-content .text .list li:before{
    color: #002c5d;
  }
  
  .job-details-content .social-box .social-links li:first-child a{
    background: #3b5999;
  }
  
  .job-details-content .social-box .social-links li:nth-child(2) a{
    background: #55acee;
  }
  
  .job-details-content .social-box .social-links li:nth-child(3) a{
    background: #dd4b39;
  }
  
  .job-details-content .social-box .social-links li:last-child a{
    background: #0077b5;
  }
  
  .job-sidebar .job-discription .list li p a:hover{
    color: #002c5d;
  }
  
  .job-sidebar .support-widget .widget-content .support-info li a:hover{
    color: #002c5d;
  }
  
  .job-sidebar .support-widget .widget-content .social-links li a:hover{
    color: #002c5d;
  }
  
  .placejob-section .form-inner .job-form .form-group i{
    color: #002c5d;
  }
  
  .advantages-section .single-item .inner-box a:hover{
    color: #002c5d;
  }
  
  .pricing-section.overview-page-2 .pricing-block-one.popular .inner-box a{
    background: #002c5d;
  }
  
  .pricing-section.overview-page-2 .tab-btn-box .tab-buttons li{
    border-color: #ddccc2;
    color: #001b4421;
    background: #001b44;
  }
  
  .sidebar-page-container .more-btn a{
    border: 1px solid #002c5d;
  }
  
  .sidebar-page-container .more-btn a:hover{
    background: #002c5d;
  }
  
  .blog-sidebar .search-widget .search-form .form-group input:focus + button,
  .blog-sidebar .search-widget .search-form .form-group button:hover{
    background: #002c5d;
  }
  
  .blog-sidebar .sidebar-widget .widget-title i{
    color: #002c5d;
  }
  
  .blog-sidebar .sidebar-widget .widget-title:before{
    background: #002c5d;
  }
  
  .blog-sidebar .categories-widget .widget-content .list li a:hover{
    color: #002c5d;
  }
  
  .blog-sidebar .categories-widget .widget-content .list li a:hover span{
    color: #002c5d;
  }
  
  .blog-sidebar .categories-widget .widget-content .list li a:before{
    background: #002c5d;
  }
  
  .blog-sidebar .post-widget .widget-content .post .post-thumb:before{
    background: #002c5d;
  }
  
  .blog-sidebar .post-widget .widget-content .post h5 a:hover{
    color: #002c5d;
  }
  
  .blog-sidebar .gallery-widget .image-list li .image-box:before{
    background: #002c5d;
  }
  
  .blog-sidebar .sidebar-resource .inner-box a i{
    color: #002c5d;
  }
  
  .blog-sidebar .sidebar-resource .inner-box a:hover{
    color: #002c5d;
  }
  
  .news-block-one .inner-box .lower-content .inner h2 a:hover{
    color: #002c5d;
  }
  
  .sidebar-page-container .news-block-one .inner-box .lower-content .inner .share-box .social-links li a:hover{
    color: #002c5d;
  }
  
  .sidebar-page-container .news-block-one .inner-box .lower-content .inner .share-box .share-link:hover{
    border-color: #002c5d;
    background: #002c5d;
  }
  
  .blog-list .news-block-one .inner-box .owl-nav .owl-prev:hover,
  .blog-list .news-block-one .inner-box .owl-nav .owl-next:hover{
    background: #002c5d;
  }
  
  .pagination li a:hover,
  .pagination li a.active{
    border-color: #002c5d;
    background: #002c5d;
  }
  
  .page-title .news-block-one .inner-box .post-date{
    background: #002c5d;
  }
  
  .blog-details-content .inner-box .post-time h3 i{
    color: #002c5d;
  }
  
  .blog-details-content .inner-box .text h3:before{
    background: #002c5d;
  }
  
  .blog-details-content .inner-box .text .list li:before{
    color: #002c5d;
  }
  
  .blog-details-content .post-share-option .social-box .social-links li:first-child a{
    background: #3b5999;
  }
  
  .blog-details-content .post-share-option .social-box .social-links li:nth-child(2) a{
    background: #55acee;
  }
  
  .blog-details-content .post-share-option .social-box .social-links li:nth-child(3) a{
    background: #dd4b39;
  }
  
  .blog-details-content .post-share-option .social-box .social-links li:last-child a{
    background: #0077b5;
  }
  
  .blog-details-content .author-box .inner span a:hover{
    color: #fa4949;
  }
  
  .blog-details-content .author-box .social-links li a:hover{
    color: #fa4949;
  }
  
  .blog-details-content .nav-btn-box .inner a i{
    color: #fa4949;
  }
  
  .blog-details-content .nav-btn-box .left-btn:hover .inner a{
    color: #fa4949;
  }
  
  .blog-details-content .nav-btn-box .right-btn:hover .inner a{
    color: #fa4949;
  }
  
  .blog-details-content .comment-box .comment .comment-inner .reply-btn{
    color: #fa4949;
  }
  
  .blog-details-content .comments-form-area .comment-form .form-group input:focus,
  .blog-details-content .comments-form-area .comment-form .form-group textarea:focus{
    border-color: #fa4949 !important;
  }
  
  .protfolio-page .more-btn a{
    border: 1px solid #fa4949;
  }
  
  .protfolio-page .more-btn a:hover{
    background: #fa4949;
  }
  
  .protfolio-page .filters .filter-tabs:before{
    background: #fa4949;
  }
  
  .protfolio-page .filters .filter-tabs li.active:before,
  .protfolio-page .filters .filter-tabs li:hover:before{
    background: #fa4949;
  }
  
  .protfolio-page .filters .filter-tabs li.active,
  .protfolio-page .filters .filter-tabs li:hover{
    color: #fa4949;
  }
  
  .locations-section .single-item .inner-box .info-list li i{
    color: #fa4949;
  }
  
  .locations-section .single-item .inner-box .info-list li a:hover{
    color: #fa4949;
  }
  
  .mobile-menu .menu-backdrop{
    background: #002c5d;
  }
 `, "",{"version":3,"sources":["webpack://./src/CustomCSS/css/color.css"],"names":[],"mappings":";;AAEA,eAAe;;AAEf;IACI,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;;IAEE,mBAAmB;EACrB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,cAAc;EAChB;;;GAGC;;IAEC,yBAAyB;EAC3B;;GAEC;;IAEC,yBAAyB;EAC3B;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,cAAc;IACd,qBAAqB;EACvB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,cAAc;IACd,qBAAqB;EACvB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,cAAc;EAChB;;EAEA;;;;IAIE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;;IAEE,mBAAmB;EACrB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,cAAc;EAChB;EACA;IACE,iBAAiB;IACjB,aAAa;AACjB;AACA;EACE,8BAA8B;EAC9B,YAAY;EACZ,eAAe;AACjB;AACA;EACE,eAAe;AACjB;EACE;IACE,mBAAmB;EACrB;;EAEA;;IAEE;EACF;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;;IAEE,cAAc;EAChB;;EAEA;IACE,2CAA2C;EAC7C;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,mBAAmB;EACrB;;EAEA;;IAEE,mBAAmB;EACrB;;EAEA;IACE,oCAAoC;EACtC;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;IACd,gCAAgC;EAClC;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;;IAEE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;;IAEE,cAAc;EAChB;;EAEA;;IAEE,mBAAmB;EACrB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;;IAEE,yBAAyB;EAC3B;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;;IAEE,cAAc;EAChB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,gCAAgC;EAClC;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,gCAAgC;EAClC;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;IACnB,qBAAqB;EACvB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;IACd,qBAAqB;EACvB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;;IAEE,mBAAmB;EACrB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;;IAEE,gCAAgC;EAClC;;EAEA;IACE,mBAAmB;EACrB;;EAEA;;IAEE,cAAc;EAChB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;;IAEE,gCAAgC;EAClC;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,cAAc;EAChB;;EAEA;;IAEE,cAAc;EAChB;;EAEA;;IAEE,qBAAqB;EACvB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,mBAAmB;IACnB,qBAAqB;EACvB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,qBAAqB;IACrB,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,mBAAmB;EACrB;;EAEA;;IAEE,mBAAmB;EACrB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,qBAAqB;IACrB,mBAAmB;EACrB;;EAEA;;IAEE,mBAAmB;EACrB;;EAEA;;IAEE,qBAAqB;IACrB,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;;IAEE,gCAAgC;EAClC;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;;IAEE,mBAAmB;EACrB;;EAEA;;IAEE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,mBAAmB;EACrB","sourcesContent":["\n\n/* color file */\n\n.scroll-top:hover{\n    background: #002c5d;\n  }\n  \n  .preloader-close{\n    background: #002c5d;\n  }\n  \n  .main-header .header-top .left-info li i{\n    color: #002c5d;\n  }\n  \n  .main-header .header-top .left-info li p a:hover{\n    color: #002c5d;\n  }\n  \n  .main-header .header-top .location-box .location-carousel p span{\n    color: #002c5d;\n  }\n  \n  .main-header .header-top .location-box .location-carousel .owl-nav .owl-prev:hover,\n  .main-header .header-top .location-box .location-carousel .owl-nav .owl-next:hover{\n    background: #002c5d;\n  }\n  \n  .main-header .header-top .location-box .apply-btn a{\n    color: #002c5d;\n  }\n  \n  .main-header .header-top .right-info .list li a:hover{\n    color: #002c5d;\n  }\n  \n  .main-header .header-top .right-info .social-links li a:hover{\n    color: #002c5d;\n  }\n  \n  .main-header .menu-right-content .search-btn button:hover{\n    color: #002c5d !important;\n  }\n  \n  .theme-btn-one:after{\n    background: #002c5d;\n  }\n  \n  .main-header .language .lang-dropdown li a:hover{\n    color: #ff5956;\n  }\n\n  \n   .main-menu .navigation > li.dropdown.current > a:before,\n   .main-menu .navigation > li.dropdown:hover > a:before{\n    color: #002c5d !important;\n  }\n  \n   .main-menu .navigation > li.current > a,\n   .main-menu .navigation > li:hover > a{\n    color: #002c5d !important;\n  }\n  \n  .main-header .language .lang-dropdown{\n    border-top: 2px solid #002c5d;\n  }\n  \n  .search-popup .close-search:hover{\n    color: #002c5d;\n    border-color: #002c5d;\n  }\n  \n  .search-popup .search-form fieldset input[type=\"submit\"]{\n    background: #002c5d;\n  }\n  \n  .search-popup .recent-searches li a:hover{\n    color: #002c5d;\n    border-color: #002c5d;\n  }\n  \n  .banner-carousel .content-box span{\n    color: #ff5956;\n  }\n  \n  .theme-btn-two{\n    background: #002c5d;\n  }\n  \n  .sec-title .top-title{\n    color: #ff5956;\n  }\n  \n  #content_block_1 .content-box .tab-btns li.active-btn i.employ-icon,\n  #content_block_1 .content-box .tab-btns li:hover i.employ-icon,\n  #content_block_1 .content-box .tab-btns li.active-btn i.arrow-icon,\n  #content_block_1 .content-box .tab-btns li:hover i.arrow-icon{\n    color: #ff5956;\n  }\n  \n  #content_block_1 .content-box .tabs-content .inner-box h5{\n    color: #002c5d;\n  }\n  \n  #content_block_1 .content-box .tabs-content .inner-box .link a:hover{\n    color: #002c5d;\n  }\n  \n  #content_block_2 .content-box .inner-box a, #Button_react{\n    background: #002c5d;\n  }\n  \n  #content_block_3 .content-box .link a:hover{\n    color: #002c5d;\n  }\n  \n  #content_block_3 .content-box .author-text h3:before{\n    background: #002c5d;\n  }\n  \n  #content_block_3 .content-box .author-text h3:after{\n    background: #002c5d;\n  }\n  \n  .service-block-one .inner-box .lower-content .overlay-content a{\n    background: #002c5d;\n  }\n  \n  .owl-dot-style-one .owl-dots .owl-dot.active span,\n  .owl-dot-style-one .owl-dots .owl-dot span:hover{\n    background: #002c5d;\n  }\n  \n  #content_block_4 .content-box .inner-box .single-item .inner h3 span{\n    color: #002c5d;\n  }\n  \n  #content_block_4 .content-box .inner-box .single-item .inner h3:before{\n    background: #002c5d;\n  }\n  \n  #content_block_4 .content-box .inner-box .single-item .inner h3 a:hover{\n    color: #ff5956;\n  }\n  #procedure figure.image-box {\n    background: white;\n    padding: 2% 0;\n}\n.col-lg-4.col-md-6.col-sm-12.process-block:hover .process-block-one .inner-box .icon-box span {\n  background: #002c5d !important;\n  color: white;\n  cursor: pointer;\n}\n.col-lg-4.col-md-6.col-sm-12.process-block:hover  { \n  cursor: pointer;\n}\n  .industries-section .content-column .tabs-content .inner-box .content-box .link a:hover{\n    background: #002c5d;\n  }\n  \n  .industries-section .tab-btns li.active-btn h3,\n  .industries-section .tab-btns li:hover h3{\n    color: #ff5956\n  }\n  \n  .process-block-one .inner-box .icon-box span{\n    color: #002c5d;\n  }\n  \n  .process-block-one .inner-box .lower-content a{\n    color: #002c5d;\n  }\n  \n  .progress-box .bar-inner{\n    background: #002c5d;\n  }\n  \n  .progress-box .bar:before{\n    background: #002c5d;\n  }\n  \n  .progress-box .bar-inner:before{\n    background: #002c5d;\n  }\n  \n  #content_block_5 .content-box .link a:hover{\n    color: #002c5d;\n  }\n  \n  #content_block_5 .content-box .sec-title{\n    margin-bottom: 30px;\n  }\n  \n  .team-block-one .inner-box .image-box .share-box .social-links li a:hover{\n    color: #002c5d;\n  }\n  \n  .team-block-one .inner-box .lower-content h3 a:hover{\n    color: #002c5d;\n  }\n  \n  .news-block-one .inner-box .image-box .post-date{\n    background: #002c5d;\n  }\n  \n  .news-block-one .inner-box .lower-content .inner .category i{\n    color: #002c5d;\n  }\n  \n  .news-block-one .inner-box .lower-content .inner h3 a:hover{\n    color: #002c5d;\n  }\n  \n  .news-block-one .inner-box .lower-content .inner .post-info li a:hover{\n    color: #002c5d;\n  }\n  \n  .testimonial-block-one .inner-box .author-box .rating li{\n    color: #002c5d;\n  }\n  \n  .footer-top .about-widget .social-links li a:hover{\n    color: #002c5d;\n  }\n  \n  .footer-top .links-widget .links-list li a:hover{\n    color: #ff5956;\n  }\n  \n  .footer-top .contact-widget .info-box li a:hover{\n    color: #ff5956;\n  }\n  \n  .main-footer .footer-subscribe .subscribe-form .form-group button:hover,\n  .main-footer .footer-subscribe .subscribe-form .form-group input:focus + button{\n    color: #ff5956;\n  }\n  \n  .main-footer .footer-subscribe .subscribe-form .form-group input:focus{\n    border-bottom: 1px solid #002c5d !important;\n  }\n  \n  .footer-bottom .copyright p a:hover{\n    color: #002c5d;\n  }\n  \n  .footer-bottom .footer-nav li a:hover{\n    color: #ff5956;\n  }\n  \n  .main-header.style-two .menu-right-content .theme-btn-one{\n    border: 1px solid #002c5d;\n  }\n  \n  .banner-carousel .btn-box .btn-one:after{\n    background: #002c5d;\n  }\n  \n  .banner-section .owl-nav .owl-prev:hover,\n  .banner-section .owl-nav .owl-next:hover{\n    background: #002c5d;\n  }\n  \n  #image_block_1 .image-box .video-inner .border{\n    border: 1px solid #002c5d !important;\n  }\n  \n  .service-style-two .inner-container .single-item h3 a:hover{\n    color: #002c5d;\n  }\n  \n  .service-style-two .inner-container .single-item .link a i{\n    color: #002c5d;\n  }\n  \n  .service-style-two .inner-container .single-item .link a:hover{\n    color: #002c5d;\n  }\n  \n  .service-style-two .inner-container .single-item .text a:hover{\n    color: #002c5d;\n    border-bottom: 1px solid #002c5d;\n  }\n  \n  .project-block-one .inner-box .content-box .text span{\n    color: #002c5d;\n  }\n  \n  .project-block-one .inner-box .content-box .text h3 a:hover{\n    color: #002c5d;\n  }\n  \n  .project-block-one .inner-box .content-box .view-btn a{\n    background: #002c5d;\n  }\n  \n  .project-section .owl-nav .owl-prev:hover,\n  .project-section .owl-nav .owl-next:hover{\n    color: #002c5d;\n  }\n  \n  .industries-style-two .tab-btn-one .tab-buttons li.active-btn i{\n    color: #002c5d;\n  }\n  \n  .industries-style-two .tabs-content-2 .inner-box .content-box .link a:hover{\n    background: #002c5d;\n  }\n  \n  .industries-style-two .tab-btn-two li.active-btn h3,\n  .industries-style-two .tab-btn-two li:hover h3{\n    color: #002c5d;\n  }\n  \n  .industries-style-two .tab-btn-two li.active-btn-2:before,\n  .industries-style-two .tab-btn-two li:hover:before{\n    background: #002c5d;\n  }\n  \n  .chooseus-block-one .inner-box a i{\n    color: #002c5d;\n  }\n  \n  .chooseus-block-one .inner-box a:hover{\n    color: #002c5d;\n  }\n  \n  .chooseus-block-one:after{\n    border: 1px solid #002c5d;\n  }\n  \n  .pricing-block-one .inner-box .text:before{\n    background: #002c5d;\n  }\n  \n  .pricing-block-one .inner-box h2{\n    color: #002c5d;\n  }\n  \n  .pricing-block-one .inner-box:hover a{\n    background: #002c5d;\n  }\n  \n  .pricing-block-one.popular .inner-box .popular-tag{\n    background: #002c5d;\n  }\n  \n  .pricing-block-one.popular .inner-box .popular-tag:before{\n    background: #002c5d;\n  }\n  \n  .pricing-block-one.popular .inner-box .popular-tag:after{\n    background: #002c5d;\n  }\n  \n  .pricing-block-one.popular .inner-box:before{\n    background: #d13634;\n  }\n  \n  .pricing-section .tab-btn-box .tab-buttons li.active-btn,\n  .pricing-section .tab-btn-box .tab-buttons li:hover{\n    color: #002c5d !important;\n  }\n  \n  .testimonial-block-two .inner-box .rating li{\n    color: #002c5d;\n  }\n  \n  .testimonial-style-two .owl-theme .owl-dots .owl-dot span:before{\n    border: 1px solid #002c5d;\n  }\n  \n  .testimonial-style-two .owl-theme .owl-dots .owl-dot.active span{\n    background: #002c5d;\n  }\n  \n  .testimonial-style-two .thumb-box .user-thumb .pattern-3{\n    background: #002c5d;\n  }\n  \n  .news-section .owl-nav .owl-prev:hover,\n  .news-section .owl-nav .owl-next:hover{\n    color: #002c5d;\n  }\n  \n  .clients-style-two .title-inner .btn-box a.btn-one{\n    background: #002c5d;\n  }\n  \n  .clients-style-two .title-inner .btn-box a.btn-one:hover{\n    color: #002c5d;\n  }\n  \n  .clients-style-two .title-inner .btn-box a.btn-two:hover{\n    background: #002c5d;\n  }\n  \n  #content_block_6 .content-box .info-list li .inner p a:hover{\n    color: #002c5d;\n  }\n  \n  #content_block_6 .content-box .info-list li .inner:after{\n    background: #002c5d;\n  }\n  \n  .main-footer .about-widget .subscribe-form .form-group input:focus{\n    border-color: #002c5d !important;\n  }\n  \n  .main-footer .about-widget .subscribe-form .form-group button:hover{\n    background: #002c5d;\n  }\n  \n  .main-footer .callback-widget .widget-content .form-group input:focus{\n    border-color: #002c5d !important;\n  }\n  \n  .main-footer .callback-widget .widget-content .form-group button{\n    background: #002c5d;\n  }\n  \n  .main-footer .callback-widget .pattern-layer .pattern-3{\n    background: #002c5d;\n  }\n  \n  .footer-bottom .social-links li a:hover{\n    background: #002c5d;\n    border-color: #002c5d;\n  }\n  \n  .banner-section.style-three .social-box .social-links li a:hover{\n    color: #002c5d;\n  }\n  \n  .banner-section.style-three .social-box .social-links:before{\n    background: #002c5d;\n  }\n  \n  .banner-section.style-three .mail-box a:hover{\n    color: #002c5d;\n  }\n  \n  .chooseus-section.alternet-2 .chooseus-block-one .inner-box a:hover{\n    color: #002c5d;\n  }\n  \n  .chooseus-section.alternet-2 .chooseus-block-one .inner-box a:hover i{\n    color: #002c5d;\n  }\n  \n  .video-section .video-content .pattern-layer .pattern-2{\n    background: #002c5d;\n  }\n  \n  .video-section .video-content .pattern-layer .pattern-3{\n    background: #e74946;\n  }\n  \n  .process-style-two .single-item .inner-box h2{\n    color: #002c5d;\n  }\n  \n  .process-style-two .single-item .inner-box h3 a:hover{\n    color: #002c5d;\n  }\n  \n  .process-style-two .single-item .inner-box .link a:hover{\n    color: #002c5d;\n  }\n  \n  .pricing-block-two .inner-box:hover a{\n    background: #e74946;\n  }\n  \n  .pricing-block-two .inner-box h2{\n    color: #002c5d;\n  }\n  \n  .pricing-block-two .inner-box .list li:before{\n    color: #002c5d;\n  }\n  \n  .project-style-two .more-text p a:hover{\n    color: #002c5d;\n    border-color: #002c5d;\n  }\n  \n  .news-section .sec-title .link:hover{\n    color: #002c5d;\n  }\n  \n  .advice-section .text h2 a{\n    color: #002c5d;\n  }\n  \n  .advice-section .social-links li a:hover{\n    background: #002c5d;\n  }\n  \n  .main-footer .logo-widget .upload-btn a{\n    border: 1px dashed #002c5d;\n  }\n  \n  .main-footer .logo-widget .upload-btn a i{\n    color: #002c5d;\n  }\n  \n  .main-footer .logo-widget .upload-btn a:hover{\n    color: #002c5d;\n  }\n  \n  .footer-top .post-widget .post-inner .post h5 a:hover{\n    color: #002c5d;\n  }\n  \n  .page-title .bread-crumb li a:hover{\n    color: #002c5d;\n  }\n  \n  .process-style-two.alternet-2 .single-item .inner-box h3 a:hover{\n    color: #002c5d;\n  }\n  \n  .process-style-two.alternet-2 .single-item .inner-box .link a:hover{\n    color: #002c5d;\n  }\n  \n  .process-style-two.alternet-2 .single-item .inner-box .link a:hover i{\n    color: #002c5d;\n  }\n  \n  .history-section .inner-box .content-box .year-box h3{\n    color: #002c5d;\n  }\n  \n  .history-section .inner-box .dots-box.active{\n    border-color: #002c5d;\n  }\n  \n  .history-section .inner-box .dots-box.active:before{\n    background: #002c5d;\n  }\n  \n  .history-section .inner-box .dots-box.active:after{\n    background: #002c5d;\n  }\n  \n  .owl-dot-style-two .owl-dots .owl-dot.active span,\n  .owl-dot-style-two .owl-dots .owl-dot span:hover{\n    background: #002c5d;\n  }\n  \n  .hiring-strategies .inner-box .funfact-inner .counter-block .count-outer{\n    color: #002c5d;\n  }\n  \n  .solutions-problems .upper-box .inner-box .single-item a:hover{\n    color: #002c5d;\n  }\n  \n  .solutions-problems .carousel-box .single-item .inner-box .side-content .content-box:after{\n    background: #002c5d;\n  }\n  \n  .solutions-problems .carousel-box .single-item .inner-box .side-content .overlay-box span{\n    color: #002c5d;\n  }\n  \n  .solutions-problems .carousel-box .single-item .inner-box .side-content .overlay-box a:hover{\n    background: #002c5d;\n  }\n  \n  .solutions-problems .carousel-box .single-item .inner-box .side-content .overlay-box:before{\n    background: #002c5d;\n  }\n  \n  .placejob-section .form-inner .job-form .form-group input:focus,\n  .placejob-section .form-inner .job-form .form-group textarea:focus{\n    border-color: #002c5d !important;\n  }\n  \n  .accordion-box .block .acc-btn.active .icon-outer{\n    background: #002c5d;\n  }\n  \n  .clients-style-three .owl-nav .owl-prev:hover,\n  .clients-style-three .owl-nav .owl-next:hover{\n    color: #002c5d;\n  }\n  \n  .hiring-section .inner-box a:after{\n    background: #002c5d;\n  }\n  \n  .default-form .form-group input:focus,\n  .default-form .form-group textarea:focus{\n    border-color: #002c5d !important;\n  }\n  \n  .service-details-content .content-two .inner-box .single-column .overlay-box .icon-box{\n    background: #002c5d;\n  }\n  \n  .service-details-content .content-two .inner-box .single-column .overlay-box h5{\n    color: #002c5d;\n  }\n  \n  .service-details-content .content-two .inner-box .single-column .overlay-box .link a:hover{\n    color: #002c5d;\n  }\n  \n  .service-details-content .content-three .tab-btns li.active-btn .icon-box{\n    color: #002c5d;\n  }\n  \n  .service-details-content .content-three .tabs-content .inner-box .text a:hover{\n    color: #002c5d;\n  }\n  \n  .service-details-content .content-four .inner-box .list-item li .icon-box{\n    color: #002c5d;\n  }\n  \n  .service-details-content .content-four .inner-box .list-item li:hover .more-content .menu-icon i{\n    color: #002c5d;\n  }\n  \n  .project-block-two .inner-box .content-box .link a{\n    background: #002c5d;\n  }\n  \n  .project-block-two .inner-box .content-box .text h3 a:hover{\n    color: #002c5d;\n  }\n  \n  .service-details-content .content-five .owl-nav .owl-prev:hover, \n  .service-details-content .content-five .owl-nav .owl-next:hover{\n    color: #002c5d;\n  }\n  \n  .service-sidebar .categories-widget .categories-list li a.active:before,\n  .service-sidebar .categories-widget .categories-list li a:hover:before{\n    border-color: #002c5d;\n  }\n  \n  .service-sidebar .categories-widget .categories-list li a:after{\n    background: #002c5d;\n  }\n  \n  .service-sidebar .recruitment-widget .widget-content .link a:hover{\n    color: #002c5d;\n  }\n  \n  .single-job-post .job-header .number p{\n    color: #002c5d;\n  }\n  \n  .single-job-post:hover .job-inner .apply-btn a{\n    background: #002c5d;\n    border-color: #002c5d;\n  }\n  \n  .job-details-content .upper-box .inner-box .info li a:hover{\n    color: #002c5d;\n  }\n  \n  .job-details-content .text .list li:before{\n    color: #002c5d;\n  }\n  \n  .job-details-content .social-box .social-links li:first-child a{\n    background: #3b5999;\n  }\n  \n  .job-details-content .social-box .social-links li:nth-child(2) a{\n    background: #55acee;\n  }\n  \n  .job-details-content .social-box .social-links li:nth-child(3) a{\n    background: #dd4b39;\n  }\n  \n  .job-details-content .social-box .social-links li:last-child a{\n    background: #0077b5;\n  }\n  \n  .job-sidebar .job-discription .list li p a:hover{\n    color: #002c5d;\n  }\n  \n  .job-sidebar .support-widget .widget-content .support-info li a:hover{\n    color: #002c5d;\n  }\n  \n  .job-sidebar .support-widget .widget-content .social-links li a:hover{\n    color: #002c5d;\n  }\n  \n  .placejob-section .form-inner .job-form .form-group i{\n    color: #002c5d;\n  }\n  \n  .advantages-section .single-item .inner-box a:hover{\n    color: #002c5d;\n  }\n  \n  .pricing-section.overview-page-2 .pricing-block-one.popular .inner-box a{\n    background: #002c5d;\n  }\n  \n  .pricing-section.overview-page-2 .tab-btn-box .tab-buttons li{\n    border-color: #ddccc2;\n    color: #001b4421;\n    background: #001b44;\n  }\n  \n  .sidebar-page-container .more-btn a{\n    border: 1px solid #002c5d;\n  }\n  \n  .sidebar-page-container .more-btn a:hover{\n    background: #002c5d;\n  }\n  \n  .blog-sidebar .search-widget .search-form .form-group input:focus + button,\n  .blog-sidebar .search-widget .search-form .form-group button:hover{\n    background: #002c5d;\n  }\n  \n  .blog-sidebar .sidebar-widget .widget-title i{\n    color: #002c5d;\n  }\n  \n  .blog-sidebar .sidebar-widget .widget-title:before{\n    background: #002c5d;\n  }\n  \n  .blog-sidebar .categories-widget .widget-content .list li a:hover{\n    color: #002c5d;\n  }\n  \n  .blog-sidebar .categories-widget .widget-content .list li a:hover span{\n    color: #002c5d;\n  }\n  \n  .blog-sidebar .categories-widget .widget-content .list li a:before{\n    background: #002c5d;\n  }\n  \n  .blog-sidebar .post-widget .widget-content .post .post-thumb:before{\n    background: #002c5d;\n  }\n  \n  .blog-sidebar .post-widget .widget-content .post h5 a:hover{\n    color: #002c5d;\n  }\n  \n  .blog-sidebar .gallery-widget .image-list li .image-box:before{\n    background: #002c5d;\n  }\n  \n  .blog-sidebar .sidebar-resource .inner-box a i{\n    color: #002c5d;\n  }\n  \n  .blog-sidebar .sidebar-resource .inner-box a:hover{\n    color: #002c5d;\n  }\n  \n  .news-block-one .inner-box .lower-content .inner h2 a:hover{\n    color: #002c5d;\n  }\n  \n  .sidebar-page-container .news-block-one .inner-box .lower-content .inner .share-box .social-links li a:hover{\n    color: #002c5d;\n  }\n  \n  .sidebar-page-container .news-block-one .inner-box .lower-content .inner .share-box .share-link:hover{\n    border-color: #002c5d;\n    background: #002c5d;\n  }\n  \n  .blog-list .news-block-one .inner-box .owl-nav .owl-prev:hover,\n  .blog-list .news-block-one .inner-box .owl-nav .owl-next:hover{\n    background: #002c5d;\n  }\n  \n  .pagination li a:hover,\n  .pagination li a.active{\n    border-color: #002c5d;\n    background: #002c5d;\n  }\n  \n  .page-title .news-block-one .inner-box .post-date{\n    background: #002c5d;\n  }\n  \n  .blog-details-content .inner-box .post-time h3 i{\n    color: #002c5d;\n  }\n  \n  .blog-details-content .inner-box .text h3:before{\n    background: #002c5d;\n  }\n  \n  .blog-details-content .inner-box .text .list li:before{\n    color: #002c5d;\n  }\n  \n  .blog-details-content .post-share-option .social-box .social-links li:first-child a{\n    background: #3b5999;\n  }\n  \n  .blog-details-content .post-share-option .social-box .social-links li:nth-child(2) a{\n    background: #55acee;\n  }\n  \n  .blog-details-content .post-share-option .social-box .social-links li:nth-child(3) a{\n    background: #dd4b39;\n  }\n  \n  .blog-details-content .post-share-option .social-box .social-links li:last-child a{\n    background: #0077b5;\n  }\n  \n  .blog-details-content .author-box .inner span a:hover{\n    color: #fa4949;\n  }\n  \n  .blog-details-content .author-box .social-links li a:hover{\n    color: #fa4949;\n  }\n  \n  .blog-details-content .nav-btn-box .inner a i{\n    color: #fa4949;\n  }\n  \n  .blog-details-content .nav-btn-box .left-btn:hover .inner a{\n    color: #fa4949;\n  }\n  \n  .blog-details-content .nav-btn-box .right-btn:hover .inner a{\n    color: #fa4949;\n  }\n  \n  .blog-details-content .comment-box .comment .comment-inner .reply-btn{\n    color: #fa4949;\n  }\n  \n  .blog-details-content .comments-form-area .comment-form .form-group input:focus,\n  .blog-details-content .comments-form-area .comment-form .form-group textarea:focus{\n    border-color: #fa4949 !important;\n  }\n  \n  .protfolio-page .more-btn a{\n    border: 1px solid #fa4949;\n  }\n  \n  .protfolio-page .more-btn a:hover{\n    background: #fa4949;\n  }\n  \n  .protfolio-page .filters .filter-tabs:before{\n    background: #fa4949;\n  }\n  \n  .protfolio-page .filters .filter-tabs li.active:before,\n  .protfolio-page .filters .filter-tabs li:hover:before{\n    background: #fa4949;\n  }\n  \n  .protfolio-page .filters .filter-tabs li.active,\n  .protfolio-page .filters .filter-tabs li:hover{\n    color: #fa4949;\n  }\n  \n  .locations-section .single-item .inner-box .info-list li i{\n    color: #fa4949;\n  }\n  \n  .locations-section .single-item .inner-box .info-list li a:hover{\n    color: #fa4949;\n  }\n  \n  .mobile-menu .menu-backdrop{\n    background: #002c5d;\n  }\n "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
